import {WinPresentationController} from "../WinPresentationController";
import {gsap} from "gsap";
import {RockBottom} from "../../RockBottom";
import {RockBottomGameMode} from "../../server/RockBottomGameMode";

export class FreespinWinController extends WinPresentationController {

    constructor() {
        super("FreespinWinController", false);
    }

    protected hasWin(): boolean {
        const data = RockBottom.model.parsedGameData;
        return ((data.mode === RockBottomGameMode.NORMAL && (data.nextMode === RockBottomGameMode.FREESPIN || data.nextMode === RockBottomGameMode.SUPER_FREESPIN)));
    }

    protected async createWinAnimation(): Promise<any> {
        const tl = gsap.timeline();
        tl.to(this, {duration: 0.1}); // Add this line because the RockBottom server didn't give scatterPositions and the empty tl doesn't continue the promise chain.
        await Promise.resolve(tl);
        await new Promise<void>(resolve => {
            RockBottom.initialCountUp.remove();
            RockBottom.bigWinCountUp.remove();
            RockBottom.freespinIntro.show(() => {
                RockBottom.keypadPlugin.setZeroBetSpinCounter(RockBottom.model.parsedGameData.freespinsLeft);
                resolve();
            });
        });
    }
}